module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rooms-managerment"
  }, [_c('h1', [_vm._v("房间管理")]), _c('div', {
    staticClass: "rooms"
  }, _vm._l((_vm.rooms), function(room) {
    return _c('div', {
      staticClass: "room"
    }, [_vm._v(_vm._s(room.no))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6804010","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/pages/Admin/RoomsManagement.vue
// module id = 468
// module chunks = 0